import { Scrollbars } from 'react-custom-scrollbars';
import styled, { css } from 'styled-components';

interface InnerProps {
    /** Where mask is hidden if '1', or visible if '0'. */
    $maskOpacity: number;
    $margin?: string;
}

export const Inner = styled.div.attrs<InnerProps>(({ $maskOpacity }) => ({
    style: { WebkitMaskImage: `linear-gradient(rgba(0, 0, 0, ${$maskOpacity}), black 60px)` },
}))<InnerProps>`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: hidden scroll;
    -webkit-overflow-scrolling: touch;
    will-change: -webkit-mask-image;

    /* Hide default scrollbar */
    -ms-overflow-style: none;
    scrollbar-width: none;

    ${({ $margin }) =>
        $margin &&
        css`
            @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
                margin: ${$margin};
            }
        `}

    &::-webkit-scrollbar {
        display: none;
    }
`;

interface TrackProps {
    $trackOffset: number;
    $showBackground?: boolean;
}

export const Track = styled.div<TrackProps>`
    position: absolute;
    width: 3px;
    ${({ $showBackground }) =>
        $showBackground &&
        css`
            @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
                background: rgba(255, 255, 255, 0.1);
            }
        `}
    transition: opacity ${({ theme }) => theme.transitions.speeds.normal}s;

    ${({ $trackOffset }) => css`
        top: ${$trackOffset}px;
        right: ${$trackOffset}px;
        bottom: ${$trackOffset}px;
    `};
`;

export const Thumb = styled.div`
    position: relative;
    width: 100%;
    background: ${({ theme }) => theme.colors.purple};
    border-radius: 30px;
    cursor: grab;
    transition:
        height ${({ theme }) => theme.transitions.speeds.slow}s,
        transform ${({ theme }) => theme.transitions.speeds.rapid}s;

    &:active {
        cursor: grabbing;
    }
`;

export const Hidden = styled.div`
    display: none;
`;

export const StyledScrollbars = styled(Scrollbars)`
    height: 100%;
    width: 100%;

    /* Show track on hover. Note: Opacity gets set on the element directly, so we have to use !important here */
    &:hover ${Track} {
        opacity: 1 !important;
    }
`;
